export const MENU_ITEMS = {
  HEAT_MAP: 'Heat map',
  CLICK_MAP: 'Click map',
  IMAGE: 'Image',
};
